import type { IKitchenOrderTracking } from '../api';

/** #262: Compras devolvió el pedido con una observación y Cocina todavía no lo reenvió. */
export const isObservedOrder = (o: Pick<IKitchenOrderTracking, 'status' | 'returnObservation'>) => o.status === 'generated' && !!o.returnObservation;

/** #262: el pedido ya terminó su circuito (mercadería recibida o pedido cerrado). Un pedido cancelado no es «finalizado». */
export const isFinalizedOrder = (o: Pick<IKitchenOrderTracking, 'status'>) => o.status === 'received' || o.status === 'closed';

export type KitchenOrderFilter = 'all' | 'observed' | 'upcoming' | 'urgent' | 'finalized';

export const KITCHEN_ORDER_FILTERS: { value: KitchenOrderFilter; label: string }[] = [
  { value: 'all', label: 'Todos' },
  { value: 'observed', label: 'Observados' },
  { value: 'upcoming', label: 'Próximos' },
  { value: 'urgent', label: 'Urgentes' },
  { value: 'finalized', label: 'Finalizados' },
];

export function matchesKitchenOrderFilter(o: IKitchenOrderTracking, filter: KitchenOrderFilter): boolean {
  switch (filter) {
    case 'observed': return isObservedOrder(o);
    case 'upcoming': return o.trafficLight === 'yellow';
    case 'urgent': return o.trafficLight === 'red';
    case 'finalized': return isFinalizedOrder(o);
    default: return true;
  }
}

export function parseKitchenOrderFilter(value: string | null): KitchenOrderFilter {
  return KITCHEN_ORDER_FILTERS.some((f) => f.value === value) ? (value as KitchenOrderFilter) : 'all';
}

export function countKitchenOrderAlerts(orders: IKitchenOrderTracking[] | undefined) {
  const list = orders ?? [];
  return {
    observed: list.filter(isObservedOrder).length,
    urgent: list.filter((o) => o.trafficLight === 'red').length,
    upcoming: list.filter((o) => o.trafficLight === 'yellow').length,
    finalized: list.filter(isFinalizedOrder).length,
  };
}
